import React, {useEffect, useCallback, useState} from "react";
import {connect} from "react-redux";
import {Select} from "antd";

import {LanguageActions} from "@redux";
import {history} from "@config";

import flagLT from "./Flags/lt.png";
import flagGB from "./Flags/gb.png";

const {Option} = Select;
const mobile = window.innerWidth < 427;

const languageSelect = [
    {
        value: "lt-LT",
        label: (
            <div className="d-flex align-items-center">
                <img src={flagLT} alt="lt-LT" className="mr-2"/>{mobile ? null : "Lietuvių"}
            </div>
        )
    },
    {
        value: "en-GB",
        label: (
            <div className="d-flex align-items-center">
                <img src={flagGB} alt="en-GB" className="mr-2"/>{mobile ? null : "English"}
            </div>
        )
    }
];

const LanguageSelect = params => {
    const urlParams = new URLSearchParams(window.location.search);
    const [languageParam] = useState(urlParams.get('language'))
    
    const currentLanguage = params.language;
    
    const languageChange = useCallback(evt => {
        params.dispatch(LanguageActions.setLanguage(evt));
        if (languageParam) {
            history.push(`${history.location.pathname}?language=${evt}`)
        }
    }, []);
    
    useEffect(() => {
        if (languageParam) {
            params.dispatch(LanguageActions.setLanguage(languageParam));
        }
    }, []);
    
    return (
        <Select
            value={currentLanguage}
            style={{
                width: mobile ? "auto" : 120
            }}
            onChange={languageChange}
        >
            {languageSelect.map((item, index) => (
                <Option value={item.value} key={index}>
                    {item.label}
                </Option>
            ))}
        </Select>
    );
};

function mapStateToProps(state) {
    const {language} = state.languageReducer;
    
    return {
        language
    };
}

const connectedLanguage = connect(mapStateToProps)(LanguageSelect);
export {connectedLanguage as LanguageSelect};
